var _path, _path2, _path3, _path4, _path5, _path6, _path7, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 38C29.4934 38 38 29.4934 38 19C38 8.50659 29.4934 0 19 0C8.50659 0 0 8.50659 0 19C0 29.4934 8.50659 38 19 38Z",
    fill: "url(#paint0_linear_6247_22681)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19 36.8125C28.8375 36.8125 36.8125 28.8375 36.8125 19C36.8125 9.16245 28.8375 1.1875 19 1.1875C9.16245 1.1875 1.1875 9.16245 1.1875 19C1.1875 28.8375 9.16245 36.8125 19 36.8125Z",
    fill: "#1A2037"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.63294 15.5357L15.5349 8.63379L22.4515 15.5504L15.5495 22.4523C13.6369 24.3649 10.5406 24.3649 8.63294 22.4523C6.72522 20.5397 6.72522 17.4434 8.63294 15.5357Z",
    fill: "url(#paint1_radial_6247_22681)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5354 15.5505C17.4479 17.463 20.5443 17.463 22.4519 15.5505C24.3597 13.6379 24.3645 10.5416 22.4519 8.63387C20.5394 6.72621 17.4431 6.72621 15.5354 8.63387C13.6277 10.5416 13.6228 13.6428 15.5354 15.5505Z",
    fill: "#00BFFC"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4514 15.5499L15.5494 22.4518L22.466 29.3684L29.368 22.4665C31.2805 20.5539 31.2805 17.4576 29.368 15.5499C27.4554 13.6422 24.359 13.6422 22.4514 15.5499Z",
    fill: "url(#paint2_radial_6247_22681)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4664 22.452C24.3789 24.3646 24.3789 27.4609 22.4664 29.3686C20.5538 31.2763 17.4575 31.2812 15.5498 29.3686C13.6421 27.456 13.6421 24.3597 15.5498 22.452C17.4624 20.5394 20.5587 20.5394 22.4664 22.452Z",
    fill: "#976CF3"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M37.2499 35.5881L37.2499 35.5881V35.5821V28.4311C37.2499 28.162 37.1299 27.9194 36.9328 27.7397L36.8612 27.6744H36.8469C36.6578 27.5381 36.4224 27.4655 36.1866 27.4655H35.6233V24.7155C35.6233 23.4037 34.9058 22.3355 33.915 21.6844C32.9318 21.0383 31.7032 20.75 30.4977 20.75C29.2923 20.75 28.0637 21.0383 27.0805 21.6844C26.0897 22.3355 25.3722 23.4037 25.3722 24.7155V27.4655H24.8089C24.5392 27.4655 24.2703 27.5604 24.0701 27.7369C23.8683 27.9151 23.75 28.1643 23.75 28.4311V35.5821C23.75 35.8507 23.8698 36.0957 24.0759 36.273C24.2759 36.4488 24.5443 36.5433 24.8133 36.5433H36.1866C36.4562 36.5433 36.7252 36.4484 36.9253 36.2718C37.1268 36.0941 37.2437 35.8469 37.2499 35.5881ZM27.4944 24.7111C27.4944 24.3575 27.5737 24.0792 27.7105 23.8487C27.8484 23.6164 28.0531 23.4185 28.3242 23.2398C28.8606 22.8863 29.6673 22.6722 30.4933 22.6722C31.3188 22.6722 32.1216 22.8861 32.6631 23.2403C32.9367 23.4193 33.1422 23.6161 33.2803 23.8475C33.4172 24.0771 33.4966 24.3551 33.4966 24.7111V27.4611H27.4944V24.7111Z",
    fill: "white",
    stroke: "url(#paint3_linear_6247_22681)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6247_22681",
    x1: 33.8438,
    y1: 1.78125,
    x2: -1.1875,
    y2: 37.4063,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00BFFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#976CF3"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_6247_22681",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(18.9325 11.9767) rotate(135) scale(14.6011)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00BFFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00BFFC",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_6247_22681",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(18.8886 25.8553) rotate(-45) scale(14.6011)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#976CF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#976CF3",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_6247_22681",
    x1: 23.7733,
    y1: 28.6444,
    x2: 37.2177,
    y2: 28.6444,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#976CF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00BFFC"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.52070a65e97659f6ec290acd96076635.svg";
export { ForwardRef as ReactComponent };